import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { COURSE_COMPONENTS } from './components';
import { ClassroomRoutingModule } from './classroom-routing.module';
import { COURSE_PAGES } from './pages';
import { SharedModule } from '@shared/shared.module';
import { ClassroomStoreModule } from './store/classroom-store.module';
import { TemplateStoreModule } from '@modules/template/student/store/template-store.module';
import { InstructorClientModule } from '@modules/instructor/client/instructor.client.module';
import { TranslocoModule } from '@ngneat/transloco';
import { ClassroomParticipantsComponent } from './pages/classroom-participants/classroom-participants.component';
import { BookingClientModule } from '@modules/booking/client/booking.client.module';
import {CountryStoreModule} from "@shared/store/country-store/country-store.module";
import {CountryResolver} from "@shared/resolvers/country.resolver";
import {CountryStoreService} from "@shared/store/country-store/services/country.store.service";

@NgModule({
  imports: [
    CommonModule,
    ClassroomRoutingModule,
    SharedModule,
    ClassroomStoreModule,
    //BookingClientModule,
    InstructorClientModule,
    TemplateStoreModule,
    TranslocoModule,
    BookingClientModule,
    CountryStoreModule

    //MapsModule,
  ],
  declarations: [...COURSE_PAGES, ...COURSE_COMPONENTS, ClassroomParticipantsComponent],
  providers: [CountryResolver,CountryStoreService],
  exports: [...COURSE_COMPONENTS],
})
export class ClassroomModule {}
